export default __webpack_public_path__ + "static/media/fasterRefueling.8354d2e0.svg";